import { Injectable } from '@angular/core';
import { environment } from '@base/environments/environment';
import { UtilsService } from '../utils.service';
import { QrMonitorModel } from '../../models/monitor/qr-monitor.model';

@Injectable({
  providedIn: 'root',
})
export class QrMonitorService {
  constructor(private Utils: UtilsService) {}

  getInstance() {
    const USER = this.Utils.getLoggedUser();
    const NODE = environment.node;
    const ENVIRONMENT = environment.production ? 'PROD' : 'DEV';

    const body: QrMonitorModel = {
      userId: USER?.username,
      userName: USER?.name,
      userPhoto: '',
      userToken: '',
      userEmail: USER?.email,
      node: NODE,
      environment: ENVIRONMENT,
      version: environment.version, // Agregar version de prod o el dia que se subio
      grouped: false,
      forcePush: false,
      app: 'GESTION_FE',
    };
    return body;
  }
}
